<template>
  <div class="app-container">
    <el-tabs v-model="active" @tab-click="handleClick" type="card" class="cardTabs">
      <el-tab-pane label="人员标签管理" name="tag"></el-tab-pane>
      <el-tab-pane label="请假类型管理" name="leaveType"></el-tab-pane>
      <!-- <el-tab-pane label="设备地点" name="place"></el-tab-pane> -->
    </el-tabs>
    <tags-list ref="tagList" v-if="active=='tag'">
      <template slot="toolbar-right">
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows('Tag')">删除</el-button>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column fixed="right" label="操作" width="60" align="center">
          <template slot-scope="{row}">
            <el-button type="text" icon="el-icon-edit" @click="edit(row)" />
          </template>
        </el-table-column>
      </template>
    </tags-list>
    <type-list ref="leaveTypeList" v-if="active=='leaveType'">
      <template slot="toolbar-right">
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows('LeaveType')">删除</el-button>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column fixed="right" label="操作" width="60" align="center">
          <template slot-scope="{row}">
            <el-button type="text" icon="el-icon-edit" @click="edit(row)" />
          </template>
        </el-table-column>
      </template>
    </type-list>
    <!-- <place-list ref="placeList" v-if="active=='place'">
      <template slot="toolbar-right">
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows('Place')">删除</el-button>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column fixed="right" label="操作" width="60" align="center">
          <template slot-scope="{row}">
            <el-button type="text" icon="el-icon-edit" @click="edit(row)" />
          </template>
        </el-table-column>
      </template>
    </place-list> -->
    <tags-dialog ref="tagDialog" @close-saved="reload" />
    <type-dialog ref="leaveTypeDialog" @close-saved="reload" />
    <place-dialog ref="placeDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import tagsList from "@/components/sys/basic/tags/list";
import tagsDialog from "@/components/sys/basic/tags/editDialog";
import typeList from "@/components/sys/basic/type/list";
import typeDialog from "@/components/sys/basic/type/editDialog";
import placeList from "@/components/sys/basic/place/list";
import placeDialog from "@/components/sys/basic/place/editDialog";

export default {
  name: "basic",
  mixins: [curdMixins],
  components: {
    tagsList,
    tagsDialog,
    typeList,
    typeDialog,
    placeList,
    placeDialog,
  },
  data() {
    return {
      active: "tag",
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    reload() {
      this.$nextTick(() => {
        this.$refs[this.active + "List"].getData();
      });
    },
    handleClick(e) {
      this.reload();
    },
    create() {
      this.$refs[this.active + "Dialog"].openCreate();
    },
    edit(row) {
      this.$refs[this.active + "Dialog"].openEdit(row);
    },
    delRows(name) {
      let rows = this.$refs[this.active + "List"].getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => item[name + "Id"]);
          this.$refs[this.active + "List"].delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>